const GAME_PRIMARY_CATEGORY_IDS = new Set([
    "CAT_3",
    "SCAT_11",
    "SCAT_12",
    "SCAT_13",
    "SCAT_14",
    "SCAT_15",
    "SCAT_16",
    "SCAT_17",
    "SCAT_18",
    "SCAT_19",
]);

export enum GameLensState {
    Submitted = "submitted",
    GameApproved = "gameApproved",
    GameNotApproved = "gameNotApproved",
}

export interface UseGameLensStateParams {
    primaryCategoryId?: string | null;
    isGameUserProvided: boolean;
}

export const getGameLensState = ({
    primaryCategoryId,
    isGameUserProvided,
}: UseGameLensStateParams): GameLensState | null => {
    if (!!primaryCategoryId && GAME_PRIMARY_CATEGORY_IDS.has(primaryCategoryId)) {
        return GameLensState.GameApproved;
    }

    if (!isGameUserProvided) {
        return null;
    }

    if (!primaryCategoryId) {
        return GameLensState.Submitted;
    }

    return GameLensState.GameNotApproved;
};

export const useGameLensState = (params: UseGameLensStateParams): GameLensState | null => {
    return getGameLensState(params);
};
